import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components';
import { InputField } from '../../fields';
import { RegistrationFormValues } from '../../models/User';
import { Row, Col } from 'antd';
import { makeRegistrationSchema } from './schema';

interface Props {
  onSubmit: (values: RegistrationFormValues) => void;
  initialValues?: Partial<RegistrationFormValues>;
}

function RegistrationForm({ onSubmit }: Props) {
  const { t } = useTranslation();
  const schema = makeRegistrationSchema(t);

  function handleOnSubmit({ oldPassword, password }: RegistrationFormValues) {
    onSubmit && onSubmit({ oldPassword, password });
  }

  function renderForm() {
    return (
      <div className="registration-form">
        <Form>
          <InputField
            name="oldPassword"
            type="password"
            size="large"
            label={t('registrationForm.oldPassword.label')}
            placeholder={t('registrationForm.oldPassword.placeholder')}
          />
          <InputField
            name="password"
            type="password"
            size="large"
            label={t('registrationForm.password.label')}
            placeholder={t('registrationForm.password.placeholder')}
          />
          <InputField
            name="passwordAgain"
            type="password"
            size="large"
            label={t('registrationForm.passwordAgain.label')}
            placeholder={t('registrationForm.passwordAgain.placeholder')}
          />
          <Row justify="center" style={{ marginTop: '30px' }}>
            <Col>
              <Button htmlType="submit" type="primary">
                {t('registrationForm.submit')}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  return (
    <Formik<RegistrationFormValues>
      initialValues={{
        oldPassword: '',
        password: '',
        passwordAgain: '',
      }}
      onSubmit={handleOnSubmit}
      validationSchema={schema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {renderForm}
    </Formik>
  );
}

export default RegistrationForm;
